// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1eVc8","active":"NavigationItem_active__3i0Bk"};